<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" class="bg-0A1129">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 10%;">
                            <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                                <h2 class="mb-3 custom-32px-600 text-center text-white">Pelan pembelajaran untuk setiap pelajaran</h2>
                                <p class="custom-24px-400 font-color-EDEDED">Belajar setiap pelajaran dengan cara yang tersusun dan mudah difahami untuk mencapai hasil yang maksimum.</p>
                               
                            </CCol>
                        </div>
                        <CCol sm="12" style="width:90%;margin: 0 auto;background-size: cover;">
                           <CRow class="mt-5">
                            <CCol sm="3">
                                <CCard class="custom-navy-border">
                                    <div class="p-2">
                                        <img src="../assets/img/flyhigh/iconQuote.png" width="30px"/>
                                        <h3 class="custom-24px-600 mt-3">Bahasa Melayu</h3>
                                        <p class="custom-18px-400 font-color-EDEDED">9 Kelas Ditawarkan</p>
                                        <CButton type="button" class="bg-1796FD border-6px text-white" block>Mula Belajar</CButton>
                                    </div>
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="custom-navy-border">
                                    <div class="p-2">
                                        <img src="../assets/img/flyhigh/iconQuote.png" width="30px"/>
                                        <h3 class="custom-24px-600 mt-3">English</h3>
                                        <p class="custom-18px-400 font-color-EDEDED">9 Kelas Ditawarkan</p>
                                        <CButton type="button" class="bg-1796FD border-6px text-white" block>Mula Belajar</CButton>
                                    </div>
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="custom-navy-border">
                                    <div class="p-2">
                                        <img src="../assets/img/flyhigh/iconQuote.png" width="30px"/>
                                        <h3 class="custom-24px-600 mt-3">Mathematic</h3>
                                        <p class="custom-18px-400 font-color-EDEDED">9 Kelas Ditawarkan</p>
                                        <CButton type="button" class="bg-1796FD border-6px text-white" block>Mula Belajar</CButton>
                                    </div>
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="custom-navy-border">
                                    <div class="p-2">
                                        <img src="../assets/img/flyhigh/iconQuote.png" width="30px"/>
                                        <h3 class="custom-24px-600 mt-3">Science</h3>
                                        <p class="custom-18px-400 font-color-EDEDED">9 Kelas Ditawarkan</p>
                                        <CButton type="button" class="bg-1796FD border-6px text-white" block>Mula Belajar</CButton>
                                    </div>
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="custom-navy-border">
                                    <div class="p-2">
                                        <img src="../assets/img/flyhigh/iconQuote.png" width="30px"/>
                                        <h3 class="custom-24px-600 mt-3">History</h3>
                                        <p class="custom-18px-400 font-color-EDEDED">9 Kelas Ditawarkan</p>
                                        <CButton type="button" class="bg-1796FD border-6px text-white" block>Mula Belajar</CButton>
                                    </div>
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="custom-navy-border">
                                    <div class="p-2">
                                        <img src="../assets/img/flyhigh/iconQuote.png" width="30px"/>
                                        <h3 class="custom-24px-600 mt-3">Physics</h3>
                                        <p class="custom-18px-400 font-color-EDEDED">9 Kelas Ditawarkan</p>
                                        <CButton type="button" class="bg-1796FD border-6px text-white" block>Mula Belajar</CButton>
                                    </div>
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="custom-navy-border">
                                    <div class="p-2">
                                        <img src="../assets/img/flyhigh/iconQuote.png" width="30px"/>
                                        <h3 class="custom-24px-600 mt-3">Biology</h3>
                                        <p class="custom-18px-400 font-color-EDEDED">9 Kelas Ditawarkan</p>
                                        <CButton type="button" class="bg-1796FD border-6px text-white" block>Mula Belajar</CButton>
                                    </div>
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="custom-navy-border">
                                    <div class="p-2">
                                        <img src="../assets/img/flyhigh/iconQuote.png" width="30px"/>
                                        <h3 class="custom-24px-600 mt-3">Accounts</h3>
                                        <p class="custom-18px-400 font-color-EDEDED">9 Kelas Ditawarkan</p>
                                        <CButton type="button" class="bg-1796FD border-6px text-white" block>Mula Belajar</CButton>
                                    </div>
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="custom-navy-border">
                                    <div class="p-2">
                                        <img src="../assets/img/flyhigh/iconQuote.png" width="30px"/>
                                        <h3 class="custom-24px-600 mt-3">Economy</h3>
                                        <p class="custom-18px-400 font-color-EDEDED">9 Kelas Ditawarkan</p>
                                        <CButton type="button" class="bg-1796FD border-6px text-white" block>Mula Belajar</CButton>
                                    </div>
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="custom-navy-border">
                                    <div class="p-2">
                                        <img src="../assets/img/flyhigh/iconQuote.png" width="30px"/>
                                        <h3 class="custom-24px-600 mt-3">Commerce</h3>
                                        <p class="custom-18px-400 font-color-EDEDED">9 Kelas Ditawarkan</p>
                                        <CButton type="button" class="bg-1796FD border-6px text-white" block>Mula Belajar</CButton>
                                    </div>
                                </CCard>
                            </CCol>
                            <CCol sm="3">
                                <CCard class="custom-navy-border">
                                    <div class="p-2">
                                        <img src="../assets/img/flyhigh/iconQuote.png" width="30px"/>
                                        <h3 class="custom-24px-600 mt-3">Geography</h3>
                                        <p class="custom-18px-400 font-color-EDEDED">9 Kelas Ditawarkan</p>
                                        <CButton type="button" class="bg-1796FD border-6px text-white" block>Mula Belajar</CButton>
                                    </div>
                                </CCard>
                            </CCol>
                           </CRow>
                        </CCol>
                       
                    </CCol>
    
                </CRow>
                </CCol>
            </CCol>
    
    
            <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../components/Footer.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

            Names: ""

        };
    },
    created() {
        AOS.init();
    },
    mounted() {
        // const isAuth = this.UserAuth();
        //     if (isAuth) {
        //     this.GetInfoUser();
        // } else {
        //     this.loading = false; // If not authenticated, immediately set loading to false
        // }
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            this.$router.push("HowItWork");
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("About");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("About");
                console.error("Error fetching user info:", error);
            }
        },
    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>